// extracted by css-extract-rspack-plugin
export default {"container":"container-1K0FY","illustration":"illustration-3bW85","heading":"heading-2C58n","button":"button-15vcB"};